import openDialog from './_widget';

export default { openDialog };
